import {getCurrentInstance} from "vue";

export const useAlert = () => {
  const vm = getCurrentInstance().proxy.$root

  return {
    showErrorAlert(response) {
      /**
       * Element UI MessageBox.alertはcancelなどの操作を行うとPromise.rejectするが、このモジュールでは単にAlertをクローズすること以外サポートしないので、空catchする
       * @see https://element-plus.org/en-US/component/message-box.html#alert
       */
      vm.$_apiAlertMixin_error(response).catch(() => {})
    }
  }
}
